import { Box, Grid, SxProps } from "@mui/material";
import { cloneDeep } from "lodash";
import { FC, useState } from "react";
import {
  AppContextType,
  FieldContextType,
  SectionErrorContextType,
  StateContext,
} from "../../context/ApplicationContext";
import { useAppSelector } from "../../store/hooks";
import PPDialog from "../UI/PPDialog";
import PPForm from "../UI/PPForm";
import { SectionConfiguration } from "../model/form-configuration";

const style: SxProps = { bgcolor: "#e6e6e6" };

const DefaultLayout: FC<{ children: JSX.Element[] }> = (children) => {
  const { form } = useAppSelector((state) => state.form);
  const [openDialog, setOpenDialog] = useState(false);

  const autoCompleteOptions = useAppSelector(
    (state) => state.form.autoCompleteOptions ?? {}
  );

  const fieldOptions = useAppSelector(
    (state) => state.form.fieldOptions ?? {}
  );

  const errorState: SectionErrorContextType = {};
  const fieldState: FieldContextType = {};

  if (Object.keys(errorState).length == 0 && form.sections) {
    form.sections.forEach((section: SectionConfiguration) => {
      errorState[section.id] = true;
      if (section.fields)
        section.fields.forEach((field) => {
          return (fieldState[field.id] = true);
        });
      else if (section.forms) {
        section.forms.forEach((form) => {
          form.sections[0].fields?.forEach((innerField) => {
            fieldState[innerField.id] = true;
          });
        });
      }
    });
  }

  const appContext: AppContextType = {
    sectionState: {
      errorState: errorState,
      hideState: {},
      completeState: {},
      stepToSection: {},
    },
    fieldState: fieldState,
    fieldHide: {},
    fieldDisable: {},
    checkboxChecked: {
      checked: {},
    },
    autoCompleteOptions: autoCompleteOptions,
    fieldOptions: fieldOptions,
    initializationFlags: {},
  };

  const [applicationContext, setApplicationContext]: [
    AppContextType,
    React.Dispatch<React.SetStateAction<AppContextType>>
  ] = useState(() => cloneDeep(appContext));

  return (
    <StateContext.Provider
      value={{ applicationContext, setApplicationContext }}
    >
      <Box>
        <Grid
          container
          spacing={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }}
          columns={{ xs: 2, sm: 4, md: 8, lg: 8, xl: 16 }}
          justifyContent="center"
        >
          <PPForm setDialogState={setOpenDialog}></PPForm>
        </Grid>
      </Box>
      <PPDialog
        title="Confirmation Dialog"
        state={openDialog}
        setState={setOpenDialog}
      />
    </StateContext.Provider>
  );
};

//DefaultLayout.whyDidYouRender = true;

export default DefaultLayout;
